import axios from "@lib/axios";

export async function getCurrentCloset() {
  const res = await axios.get("closet");
  return res.data.data;
}

export async function getCloset(id) {
  const res = await axios.get(`closets/${id}`);
  return res.data.data;
}

export async function getPreviousClosets(controller, page) {
  const res = await axios.get(`closets?page=${page}&offset=1`, { signal: controller.signal });
  return res.data;
}

export async function putCloset(id, data) {
  const res = await axios.put(`closets/${id}`, { closet: data });
  return res.data.data;
}

export async function getReturnClosetState(closetUID) {
  const res = await axios.put(`users/closets/track_returns/${closetUID}`);

  return res.data;
}

export async function getAddOnsSummary(closetId, params) {
  const res = await axios.get(`closets/${closetId}/add_ons_summary`, { params });

  return res.data;
}

export async function getExpressDeliveryDates(closetId) {
  const res = await axios.get(`closets/${closetId}/express_delivery_dates`);

  return res.data;
}

export async function getExpressDeliverySummary(closetId) {
  const res = await axios.get(`closets/${closetId}/express_delivery_summary`);

  return res.data;
}
